import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Input, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import SandboxDefinition from "../../../types/SandboxDefinition";

interface CreateSandboxDialogProps { 
    definition?: SandboxDefinition;
    isOpen: boolean;
    setIsOpen: (value: boolean) => void;
    onSave: (name: string, definition?: SandboxDefinition) => void;
}

export default function CreateSandboxDialog(props: CreateSandboxDialogProps) {
    const [name, setName] = useState<string>("");

    useEffect(() => {
        if(props.definition)
            setName(props.definition.name);
    }, [props.definition]);

    const closeDialog = () => {
        props.setIsOpen(false);
        setName("");
    }

    const saveClicked = () => {
        props.onSave(name, props.definition);
        closeDialog();
    }

    return (
        <>
            <Dialog open={props.isOpen} fullWidth maxWidth='md' onClose={closeDialog}>
                <DialogTitle>Create Sandbox</DialogTitle>
                <DialogContent>
                    <TextField fullWidth 
                        label="Name..."
                        value={name} 
                        onChange={(e) => setName(e.target.value)} />
                </DialogContent>
                <DialogActions>
                <Button color='inherit' onClick={closeDialog}>
                    CANCEL
                </Button>
                <Button variant='contained' color='success' onClick={saveClicked}>
                    OK
                </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}